import {
    createCombinedReducer,
    createModuleFactory,
    IModuleFactory,
} from '@omaze/redux';
import { Reducer } from 'redux';

import { addSnackbarMessageReducer } from './actions/AddSnackbarMessage/AddSnackbarMessage';
import { removeSnackbarMessageReducer } from './actions/RemoveSnackbarMessage/RemoveSnackbarMessage';
import { SNACKBAR_NAMESPACE } from './Snackbar.factories';
import { ISnackbarState } from './Snackbar.state';

const initialState: ISnackbarState = {
    AUTO_ID: 0,
    messages: [],
};

const snackbarReducer: Reducer<ISnackbarState> = createCombinedReducer<ISnackbarState>(
    [
        addSnackbarMessageReducer,
        removeSnackbarMessageReducer,
    ],
    initialState,
);

export const getSnackbarModule: IModuleFactory = createModuleFactory<ISnackbarState>(
    SNACKBAR_NAMESPACE,
    snackbarReducer,
);
